import React, { Fragment } from "react"
import PropTypes from "prop-types"

import Attribute from "./Attribute"
import LabelledAttribute from "ui/components/LabelledAttribute"

const AttributeList = props => {
    const attributes = (props.fields || []).map(field => (
        <LabelledAttribute
            label={field.label || field.api_name}
            dontHideOverflow={["dropdown", "lookup"].indexOf(field.type) !== -1}
        >
            <Attribute
                field={field}
                editable={props.editable}
                inline
                onChange={value => props.onChange({ [field.api_name]: value })}
            >
                {(props.data || {})[field.api_name]}
            </Attribute>
        </LabelledAttribute>
    ))
    return <Fragment>{attributes}</Fragment>
}

AttributeList.propTypes = {
    data: PropTypes.object,
    fields: PropTypes.array,
    onChange: PropTypes.func,
}

export default AttributeList



// WEBPACK FOOTER //
// ./src/features/records/components/AttributeList.js